/* eslint-disable */

<template>
  <div class="vx-col" id="Lgx02625369515967645746014">
    <vue-sortable :options="options" @drag:start="startedDrag" @drag:stop="stoppedDrag" @sortable:sort="sort">
      <vx-card class="mb-base">
        <div class="flex flex-col gap-5 xl:gap-0 xl:flex-row xl:items-center justify-between">
          <span class="flex flex-col lg:items-center lg:flex-row gap-1 xl:gap-2">
            <h2 class="font-semibold text-white">Task:</h2>
            <h2 class="text-grey">{{ partHeaders[currentPart - 1] }}</h2>
          </span>

          <div class="flex gap-3">
            <vs-button
              class="font-bold flex part-tab"
              :class="{ 'part-tab-active': currentPart == 1 }"
              :color="currentPart == 1 ? '#FFB96F' : 'grey'"
              type="filled"
              @click="currentPart = 1"
              >Part 1</vs-button
            >
            <vs-button
              :disabled="completedParts < 1"
              class="font-bold flex part-tab"
              :class="{ 'part-tab-active': currentPart == 2 }"
              :color="currentPart == 2 ? '#FFB96F' : 'grey'"
              type="filled"
              @click="currentPart = 2"
              >Part 2</vs-button
            >
            <vs-button
              :disabled="completedParts < 2"
              class="font-bold flex part-tab"
              :class="{ 'part-tab-active': currentPart == 3 }"
              :color="currentPart == 3 ? '#FFB96F' : 'grey'"
              type="filled"
              @click="currentPart = 3"
              >Part 3</vs-button
            >
            <vs-button
              :disabled="completedParts < 3"
              class="font-bold flex part-tab"
              :class="{ 'part-tab-active': currentPart == 4 }"
              :color="currentPart == 4 ? '#FFB96F' : 'grey'"
              type="filled"
              @click="currentPart = 4"
              >Part 4</vs-button
            >
          </div>
        </div>

        <div v-if="currentPart < 4">
          <vx-card class="bg-light mt-6">
            <p class="font-semibold text-xl mb-4">
              <span class="text-primary text-2xl" style="line-height: 0.7rem">></span>
              Local host command output
            </p>
            <div class="grid grid-cols-2 text-grey font-medium">
              <div class="flex flex-col gap-2">
                <p>cat ~/.ssh/authorized_keys</p>
                <p>cat ~/.ssh/known_hosts</p>
                <p>ls -l .ssh</p>
                <p>ls -l ~</p>
                <p>ls -l ~/.ssh</p>
              </div>
              <div class="flex flex-col gap-2">
                <p>ls -l /etc/ssh</p>
                <p>ssh-add ~/.ssh/admin</p>
                <p>ssh-keyscan -H server1 >> ~/.ssh/known_hosts</p>
              </div>
            </div>
          </vx-card>

          <div class="grid grid-cols-5 gap-3 mt-6">
            <h5
              v-for="control in controls"
              :key="control"
              class="command-item"
              :class="{
                selected: answers[currentPart - 1].includes(control),
                available: !answers[currentPart - 1].includes(control),
                'cursor-pointer': currentPart > completedParts,
              }"
              @click="currentPart > completedParts && selectCommandItem(control)"
            >
              {{ control }}
            </h5>
          </div>

          <div
            class="bg-light rounded-lg border flex flex-col gap-6 lg:gap-0 lg:flex-row lg:items-center justify-between p-3 mt-6 main-border lg:h-16"
          >
            <div class="flex items-center gap-4">
              <div class="flex flex-wrap items-center gap-x-2 gap-y-1">
                <h5>[revolut@localhost ~] $</h5>
                <span
                  class="py-1 px-2 rounded-lg w-fit flex justify-center font-medium"
                  :class="{
                    unavailable: wrongAnswers.includes(answer),
                    selected: !wrongAnswers.includes(answer),
                    available: completedParts >= currentPart,
                    'cursor-trash': completedParts < currentPart,
                  }"
                  v-for="(answer, index) in answers[currentPart - 1]"
                  @click="completedParts < currentPart && unselectCommandItem(answer)"
                  :key="index"
                >
                  {{ answer }}
                </span>
              </div>
            </div>

            <span class="flex items-center gap-2" v-if="completedParts < currentPart">
              <vs-button color="danger" size="small" class="w-fit flex-shrink-0 p-0 flex items-center justify-center" @click="resetAnswers">
                <font-awesome-icon icon="fa-regular fa-rotate-left" class="h-4 w-4" />
                Reset
              </vs-button>
              <vs-button
                color="success"
                size="small"
                class="w-fit p-0 flex items-center justify-center flex-shrink-0 text-xl"
                @click="checkPartCompletion"
              >
                <font-awesome-icon icon="fa-regular fa-check" class="h-4 w-4" />
                Check
              </vs-button>
            </span>

            <span class="flex items-center gap-2" v-else>
              <vs-button color="primary" size="small" class="w-fit p-0 flex flex-col items-center justify-center" @click="currentPart++">
                Next Part
              </vs-button>
            </span>
          </div>
        </div>

        <div class="vx-row mt-6" v-else>
          <div class="vx-col lg:w-5/12 md:w-5/12 sm:w-5/5">
            <vx-card class="bg-light">
              <h5 class="text-xl">Select the proper file to edit for remote server access:</h5>
              <div class="flex flex-col gap-4 mt-6">
                <vs-button
                  size="small"
                  :color="partFour.file.value === '~/.ssh/config' ? 'primary' : 'grey'"
                  class="flex flex-col items-center justify-center"
                  :style="{
                    background:
                      partFour.file.value === '~/.ssh/config' && partFour.file.correct == false
                        ? '#c93738 !important'
                        : partFour.file.value === '~/.ssh/config' && partFour.file.correct == true
                        ? '#31b952 !important'
                        : '#808080',
                  }"
                  @click="!partFour.file.correct && selectFileItem('~/.ssh/config')"
                >
                  ~/.ssh/config
                </vs-button>
                <vs-button
                  :color="partFour.file.value === '~/.ssh/known_hosts' ? 'primary' : 'grey'"
                  size="small"
                  class="flex flex-col items-center justify-center"
                  :style="{
                    background:
                      partFour.file.value === '~/.ssh/known_hosts' && partFour.file.correct == false
                        ? '#c93738'
                        : partFour.file.value === '~/.ssh/known_hosts' && partFour.file.correct == true
                        ? '#28c76f !important'
                        : '#808080',
                  }"
                  @click="!partFour.file.correct && selectFileItem('~/.ssh/known_hosts')"
                >
                  ~/.ssh/known_hosts
                </vs-button>
                <vs-button
                  :color="partFour.file.value === '~/.ssh/server1' ? 'primary' : 'grey'"
                  size="small"
                  class="flex flex-col items-center justify-center"
                  :style="{
                    background:
                      partFour.file.value === '~/.ssh/server1' && partFour.file.correct == false
                        ? '#c93738 !important'
                        : partFour.file.value === '~/.ssh/server1' && partFour.file.correct == true
                        ? '#28c76f !important'
                        : '#808080',
                  }"
                  @click="!partFour.file.correct && selectFileItem('~/.ssh/server1')"
                >
                  ~/.ssh/server1
                </vs-button>
                <vs-button
                  :color="partFour.file.value === '~/.ssh/authorized_keys' ? 'primary' : 'grey'"
                  size="small"
                  class="flex flex-col items-center justify-center"
                  :style="{
                    background:
                      partFour.file.value === '~/.ssh/authorized_keys' && partFour.file.correct == false
                        ? '#c93738 !important'
                        : partFour.file.value === '~/.ssh/authorized_keys' && partFour.file.correct == true
                        ? '#28c76f !important'
                        : '#808080',
                  }"
                  @click="!partFour.file.correct && selectFileItem('~/.ssh/authorized_keys')"
                >
                  ~/.ssh/authorized_keys
                </vs-button>
              </div>
            </vx-card>
          </div>

          <div class="vx-col lg:w-7/12 md:w-7/12 sm:w-5/5">
            <vx-card class="bg-light">
              <h5 class="text-xl">Host server1</h5>
              <div class="grid grid-cols-2 gap-5 mt-6">
                <div v-for="(item, index) in partFour.dropdown" :key="index">
                  <v-select
                    class="w-full"
                    :options="dropdownOptions"
                    v-model="partFour.dropdown[index].value"
                    placeholder="Select output"
                  />

                  <div class="mt-1">
                    <small v-if="item.correct !== null && item.correct === false" class="text-danger font-semibold"
                      >This answer is invalid</small
                    >
                    <small v-if="item.correct !== null && item.correct === true" class="text-success font-semibold"
                      >This answer is correct</small
                    >
                  </div>
                </div>
              </div>
            </vx-card>
          </div>
        </div>
      </vx-card>
    </vue-sortable>
  </div>
</template>

<script>
import Vue from 'vue';
import vSelect from 'vue-select';
import draggable from 'vuedraggable';

export default {
  data() {
    return {
      dataLocal: JSON.parse(JSON.stringify(this.data)),
      draggingCard: false,
      currentPart: 1,
      completedParts: 0,

      options: {
        draggable: '.dragBlock',
        dropzone: '.dropzoneStandard',
      },

      partHeaders: [
        'Move the private key into the SSH folder',
        'Set the correct file permissions',
        'Set the correct ownership',
        'Edit the configuration file',
      ],

      controls: [
        '1777',
        'chown',
        'mv',
        'server1',
        ':',
        '0444',
        'revolut',
        'root',
        '/etc/ssh',
        'chcon',
        '0500',
        ';',
        'chage',
        '0600',
        'localhost',
        '~/',
        '~/.ssh/',
        'admin',
        '0777',
        'chmod',
        'server2',
        '-',
        '-R',
        '/',
        '⎵',
      ],

      dropdownOptions: [
        '2222',
        'server1',
        'RemoteServer',
        'admin',
        'Compression',
        '~/.ssh/authorized_keys',
        'User',
        'Port',
        'Yes',
        '22',
        'revolut',
        '~/.ssh/server1',
        'INFO',
        'Host',
        'HostName',
        '4444',
        'IdentityFile',
        '~/.ssh/id_rsa',
        '~/.ssh/admin',
        'LogLevel',
      ],

      sequences: [
        ['mv', '⎵', '~/', 'admin', '⎵', '~/.ssh/'],
        ['chmod', '⎵', '0600', '⎵', '~/.ssh/', 'admin'],
        ['chown', '⎵', 'revolut', '⎵', '~/.ssh/', 'admin'],
      ],

      partFour: {
        file: {
          correct: null,
          value: null,
        },
        dropdown: [
          { correct: null, value: null, answer: 'HostName' },
          { correct: null, value: null, answer: 'server1' },
          { correct: null, value: null, answer: 'Port' },
          { correct: null, value: null, answer: '2222' },
          { correct: null, value: null, answer: 'User' },
          { correct: null, value: null, answer: 'admin' },
          { correct: null, value: null, answer: 'IdentityFile' },
          { correct: null, value: null, answer: '~/.ssh/admin' },
        ],
      },

      answers: [[], [], [], []],
      wrongAnswers: [],
    };
  },
  methods: {
    startedDrag(x) {
      x.data.source.className += ' currently-dragging-standard-command';
      this.draggingCard = true;
    },
    stoppedDrag() {
      this.draggingCard = false;
    },
    sort(x) {
      const overContainer = x.data.dragEvent.data.overContainer;
      const sourceContainer = x.data.dragEvent.data.sourceContainer;
      if (overContainer && overContainer.id !== 'wordBank' && overContainer.children) {
        if (overContainer.children.length > 0 && overContainer.id !== sourceContainer.id) {
          //this.drag_error()
          x.cancel();
        }
      }
    },
    selectCommandItem(value) {
      if (this.answers[this.currentPart - 1].length === this.sequences[this.currentPart - 1].length) return;
      Vue.set(this.answers, this.currentPart - 1, [...this.answers[this.currentPart - 1], value]);
    },
    unselectCommandItem(value) {
      const newAnswersArray = this.answers[this.currentPart - 1].filter((item) => item !== value);
      Vue.set(this.answers, this.currentPart - 1, newAnswersArray);

      const newWrongAnswersArray = this.wrongAnswers.filter((item) => item !== value);
      Vue.set(this, 'wrongAnswers', newWrongAnswersArray);
    },
    selectFileItem(value) {
      this.partFour.file.value = value;
      this.partFour.file.correct = null;
    },
    resetAnswers() {
      this.answers[this.currentPart - 1] = Vue.set(this.answers, this.currentPart - 1, []);
      this.wrongAnswers = Vue.set(this.wrongAnswers, this.currentPart - 1, []);
    },
    checkPartCompletion() {
      this.wrongAnswers = [];

      const correctSequence = this.sequences[this.currentPart - 1];

      correctSequence.forEach((expected, idx) => {
        if (this.answers[this.currentPart - 1][idx] !== expected) {
          this.wrongAnswers.push(this.answers[this.currentPart - 1][idx]);
        }
      });

      if (this.wrongAnswers.length === 0) {
        this.completedParts = this.completedParts + 1;
        console.log(this.completedParts);
      }
    },
    markSimulation() {
      let totalScore = 0;

      if (this.partFour.file.value === '~/.ssh/config') {
        totalScore++;
        this.partFour.file.correct = true;
      } else {
        this.partFour.file.correct = false;
      }

      this.partFour.dropdown.forEach((item) => {
        if (item.answer === item.value) {
          totalScore++;
          item.correct = true;
        } else {
          item.correct = false;
        }
      });

      if (totalScore === this.dataLocal.simulation.totalScore) {
        return this.$emit('simulation_full_correct', totalScore);
      }

      this.$emit('simulation_getting_there', totalScore);
    },
  },
  components: {
    vSelect,
    draggable,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
#Lgx02625369515967645746014 {
  .command-item {
    padding: 0.5rem;
    border-radius: 0.5rem;
    display: flex;
    justify-content: center;
  }
  .unavailable {
    border: 1px solid rgb(201, 56, 56, 0.7);
    background-color: rgba(201, 55, 56, 0.1);
  }
  .selected {
    border: 1px solid #0053ff;
    background-color: rgba(0, 83, 255, 0.1);
  }
  .available {
    border: 1px solid rgba(49, 185, 82, 0.7);
    background-color: rgba(49, 185, 82, 0.08);
  }

  .part-tab-active {
    background: #ffb96f !important;
    border-color: #ffb96f !important;
    color: #1a1a1a !important;
  }
}
</style>
